<template>
  <div class="turnover-filters" ref="test">
    <div class="row">
      <div class="col-md-4 col-md-push-8 save-search">
        <button v-if="showResetButton" type="button" class="brocom-button-icon border reset-search-form" onclick="resetSearchForm()">
          <i class="brocom brocom-close"></i>
          <i class="brocom-button-icon-ripple"></i>
        </button>
        <button v-if="showFiltersButton"
                :disabled="!this.canSubmit"
                type="button"
                class="brocom-button-color"
                onclick="initializeDataTable()">
          {{ trans('labels.submit') }}
        </button>
        <div v-if="showButtons" class="turnover-filters-buttons">
          <input type="hidden" name="request" value="true">
          <button type="submit" class="brocom-button-color" :disabled="!this.canSubmit">
            {{ trans('labels.search') }}
          </button>
        </div>
        <button v-if="this.canSubmit && showSaveButton" type="button" class="brocom-button" data-toggle="modal" data-target="#storeSearchTitle">
          Suche speichern
        </button>
        <div class="modal fade brocom-modal" id="storeSearchTitle" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document" ref="vuemodal">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        onclick="close_save()"><span aria-hidden="true"><i
                    class="brocom brocom-close"></i> <i
                    class="brocom-button-icon-ripple"></i></span></button>
              </div>
              <div class="modal-body">
                <div class="form-group brocom-text-field">
                  <input type="text" :placeholder="trans('labels.filters.stored_set_name')" value="">
                  <span class="brocom-text-field-line"></span>
                </div>
                <div class="brocom-checkbox" v-if="saveCurrentDate">
                  <div class="">
                    <label for="save_current_date">
                      <input id="save_current_date" type="checkbox">
                      <i class="brocom-checkbox__icon"></i>
                      <span class="brocom-checkbox__label">{{ trans('labels.save_current_date') }}</span>
                      <i class="brocom-checkbox__icon-ripple"></i>
                    </label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" data-dismiss="modal" class="brocom-button" onclick="close_save()">
                  {{ trans('labels.cancel') }}
                </button>
                <button type="button" class="brocom-button-color" onclick="send_save()">
                  Suche speichern
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-md-pull-4">
        <div class="row">
          <div class="col-md-3" v-if="publishers && publishers.length > 0">
            <div class="form-group brocom-select2">
              <label for="publisher_id">{{ trans('labels.filters.publisher') }}</label>
              <select2 name="publisher_id" id="publisher_id"
                       :placeholder="trans('labels.filters.publisher')"
                       :options="publishers"
                       :name="'publisher_id'"
                       :selected="this.sel.publisher_id"
                       :onSelect="resetRelatedEntites"
                       :isUndefined="true"
                       :isAll="false"></select2>
            </div>
          </div>
          <div class="col-md-3" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.publisher') }}</label>
              <div>{{ trans('labels.filters.publisher') }}</div>
            </div>
          </div>

          <div class="col-md-3" v-if="editorials && editorials.length > 0">
            <div class="form-group brocom-select2">
              <label for="editorial_id">{{ trans('labels.filters.editorial') }}</label>
              <select2 :name="'editorial_id[]'" id="editorial_id" ref="editorial_id"
                       :placeholder="trans('labels.filters.editorial')"
                       :options="editorialDynamic"
                       :disabled="this.editorialsDisabled"
                       :selected="this.sel.editorial_id"
                       :onChange="function a(){}"
                       :isAll="true"
                       multiple></select2>
            </div>
          </div>
          <div class="col-md-3" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.editorial') }}</label>
              <div>{{ trans('labels.filters.editorial') }}</div>
            </div>
          </div>

          <div class="col-md-3" v-if="titleGroups && titleGroups.length > 0">
            <div class="form-group brocom-select2">
              <label for="title_group_id">{{ trans('labels.filters.title_group') }}</label>
              <select2 :name="'title_group_id[]'" id="title_group_id" ref="title_group_id"
                       :placeholder="trans('labels.filters.title_group')"
                       :options="titleGroupsDynamic"
                       :disabled="this.titleGroupDisabled"
                       :selected="this.sel.title_group_id"
                       :onChange="function a(){}"
                       :isAll="true"
                       multiple></select2>
            </div>
          </div>
          <div class="col-md-3" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.title_group') }}</label>
              <div>{{ trans('labels.filters.title_group') }}</div>
            </div>
          </div>

          <div class="col-md-3" v-if="salesPeopleDynamic && salesPeopleDynamic.length > 0">
            <div class="form-group brocom-select2">
              <label for="sales_person_id">{{ trans('labels.filters.sales_person') }}</label>
              <select2 :name="'sales_person_id[]'" id="sales_person_id" ref="sales_person_id"
                       :placeholder="trans('labels.filters.sales_person')"
                       :options="salesPeopleDynamic"
                       :selected="this.sel.sales_person_id"
                       :onChange="function a(){}"
                       :isAll="true"
                       multiple></select2>
            </div>
          </div>
          <div class="col-md-3" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.sales_person') }}</label>
              <div>{{ trans('labels.filters.sales_person') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2" v-if="customersType && customersType.length > 0">
            <div class="form-group brocom-select2">
              <label for="customer_type_id">{{ trans('labels.filters.customers_type') }}</label>
              <select2 :name="'customer_type_id[]'" id="customer_type_id" ref="customer_type_id"
                       :placeholder="trans('labels.filters.customers_type')"
                       :options="customersType"
                       :selected="this.sel.customer_type_id"
                       :isAll="true"
                       :onChange="function a(){}"
                       :disabled="!this.selected.publisher_id"
                       nultiple></select2>
            </div>
          </div>
          <div class="col-md-2" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.customers_type') }}</label>
              <div>{{ trans('labels.filters.customers_type') }}</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group brocom-select2">
              <label for="tax_rate">{{ trans('labels.filters.tax_rate') }}</label>
              <select2 :name="'tax_rate'" id="tax_rate" ref="tax_rate"
                       :placeholder="trans('labels.filters.tax_rate')"
                       :options="taxRatesDynamic"
                       :selected="this.sel.tax_rate"
                       :onChange="function a(){}"
                       :isAll="true"
                       :disabled="this.taxRatesDisabled"></select2>
            </div>
          </div>

          <div class="col-md-2" v-if="customerGroups && customerGroups.length > 0">
            <div class="form-group brocom-select2">
              <label for="customer_group_id">{{ trans('labels.filters.customer_group') }}</label>
              <select2 :name="'customer_group_id[]'" id="customer_group_id" ref="customer_group_id"
                       :placeholder="trans('labels.filters.customer_group')"
                       :options="customerGroupsDynamic"
                       :disabled="this.customerGroupsDisabled"
                       :selected="this.sel.customer_group_id"
                       :onChange="function a(){}"
                       :isAll="true"
                       multiple></select2>
            </div>
          </div>

          <div class="col-md-2" v-else>
            <div class="brocom-fake-select form-group">
              <label>{{ trans('labels.filters.customer_group') }}</label>
              <div>{{ trans('labels.filters.customer_group') }}</div>
            </div>
          </div>

          <div class="col-md-2" v-if="branch2 && branch2.length > 0">
            <div class="form-group brocom-select2">
              <label for="branch2">{{ trans('labels.filters.branch2') }}</label>
              <select2 :name="'branch2[]'" id="branch2" ref="branch2"
                       :placeholder="trans('labels.filters.branch2')"
                       :options="branch2Dynamic"
                       :disabled="this.branch2Disabled"
                       :selected="this.sel.branch2"
                       :onChange="function a(){}"
                       :isAll="true"
                       multiple></select2>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group brocom-select2">
              <label for="country">{{ trans('labels.filters.country') }}</label>
              <select2 :name="'country[]'" id="country" ref="country"
                       :placeholder="trans('labels.filters.country')"
                       :options="countriesDynamic"
                       :disabled="this.countriesDisabled"
                       :selected="this.sel.country"
                       :isAll="true"
                       :onChange="countryChange"
                       multiple></select2>
            </div>
          </div>

          <div v-if="bundesLand && bundesLand.length > 0 && this.showBundesland" class="col-md-2">
            <div class="form-group brocom-select2">
              <label for="bundesLand_id">{{ trans('labels.filters.bundes_land') }}</label>
              <select2 :name="'bundesland_id[]'" id="bundesland_id" ref="bundesland_id"
                       :placeholder="trans('labels.filters.bundes_land')"
                       :options="bundesLandDynamic"
                       :isAll="true"
                       :selected="this.sel.bundesland_id"
                       :onChange="function a(){}"
                       :disabled="this.bundesLandDisabled"
                       multiple></select2>
            </div>
          </div>
          <div v-if="actionNumbers && actionNumbers.length > 0" class="col-md-2">
            <div class="form-group brocom-select2">
              <label for="action_number">{{ trans('labels.filters.action_number') }}</label>
              <select2 :name="'action_number[]'" id="action_number" ref="action_number"
                       :placeholder="trans('labels.filters.action_number')"
                       :options="actionNumbersDynamic"
                       :isAll="true"
                       :selected="this.sel.action_number"
                       :onChange="function a(){}"
                       :disabled="this.actionNumberDisabled"
                       multiple></select2>
            </div>
          </div>
          <!-- <div class="col-md-2" v-else>
              <div class="brocom-fake-select form-group">
                  <label>{{ trans('labels.filters.bundes_land') }}</label>
                  <div>{{ trans('labels.filters.bundes_land') }}</div>
              </div>
          </div>-->
        </div>
        <div class="row">
          <div v-if="releasePeriod.length" class="col-md-2">
            <div class="form-group brocom-select2">
              <label for="release_period">{{ trans('labels.filters.release_period') }}</label>
              <select2 :name="'release_period'" id="release_period" ref="release_period"
                       :placeholder="trans('labels.filters.release_period')"
                       :options="releasePeriod"
                       :isAll="true"
                       :selected="this.selected.release_period"
                       :onChange="function a(){}"
                       multiple></select2>
            </div>
          </div>

          <div class="col-md-2" v-if="affiliate">
            <div class="form-group brocom-select2">
              <label :for="affiliate.id">{{ affiliate.placeholder }}</label>
              <select2 :name="affiliate.name+'[]'"
                       :ref="affiliate.id"
                       :id="affiliate.id"
                       :placeholder="affiliate.placeholder"
                       :options="JSON.parse(affiliate.options)"
                       :isAll="JSON.parse(affiliate.isAll)"
                       :selected="affiliate.selected"
                       :onChange="function a(){}"
                       multiple></select2>
            </div>
          </div>
          <div class="col-md-2" v-if="salesChannel">
            <div class="form-group brocom-select2">
              <label :for="salesChannel.id">{{ salesChannel.placeholder }}</label>
              <select2 :name="salesChannel.name"
                       :ref="salesChannel.id"
                       :id="salesChannel.id"
                       :placeholder="salesChannel.placeholder"
                       :options="JSON.parse(salesChannel.options)"
                       :isAll="JSON.parse(salesChannel.isAll)"
                       :selected="salesChannel.selected"
                       :onChange="function a(){}"></select2>
            </div>
          </div>
          <div class="col-md-4" v-if="isHeadOfGroup && canSelectPublisherGroup">
            <div class="form-group brocom-select2">
              <label for="subPublishers">{{ trans('labels.filters.subpublishers') }}</label>
              <select2 :name="'subpublishers[]'" id="subpublishers" ref="subpublishers"
                       :placeholder="trans('labels.filters.subpublishers')"
                       :options="subpublishers"
                       :isAll="true"
                       :selected="this.selected.subpublishers"
                       :onChange="function a(){}"
                       :fillNotAll="true"
                       multiple></select2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    publishers: {
      type: Array,
      default() {
        return []
      }
    },
    publisherGroups: {
      type: Array,
      default() {
        return []
      }
    },
    subPublishersStorage: {
      type: Array,
      default() {
        return []
      }
    },
    defaultPublisher: {
      type: Number,
      default() {
        return null;
      }
    },
    user: {},
    isAdmin: {
      type: Boolean,
      default() {
        return false;
      }
    },
    editorials: {
      type: Array,
      default() {
        return []
      }
    },
    taxRates: {
      type: Array,
      default() {
        return []
      }
    },
    salesPeople: {
      type: Array,
      default() {
        return []
      }
    },
    affiliate: {
      type: Object | null,
      default() {
        return null;
      }
    },
    salesChannel: {
      type: Object | null,
      default() {
        return null;
      }
    },
    countries: {
      type: Array,
      default() {
        return []
      }
    },
    actionNumbers: {
      type: Array,
      default() {
        return []
      }
    },
    titleGroups: Array,
    customerGroups: Array,
    branch2: Array,
    bundesLand: {
      type: Array,
      default() {
        return []
      }
    },
    releasePeriod: Array,
    selected: Object,
    showButtons: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showSaveButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showFiltersButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    canSelectRedactionTitles: {
      type: Boolean,
      default() {
        return true;
      }
    },
    canSelectPublisherGroup: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showResetButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    saveCurrentDate: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data: function () {
    return {
      ef: [], //editorials filtered
      tgf: [], ///Title groups filtered
      cgf: [], //customer groups
      braf: [], //branch2
      spf: [], //sales people
      countf: [], //countries
      blf: [], //bundes land
      taxf: [],  //taxes
      anf: [],  //action numbers
      subpublishers: [],
      canSubmit: true,
      publisherChangedFunction: 'publisherChanged',
      sel: this.selected,
      isHeadOfGroup: false,
      showBundesland: false
    };
  },
  computed: {
    editorialsDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.editorial_id);
      }
    },
    titleGroupDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.title_group_id);
      }
    },
    customerGroupsDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.customer_group);
      }
    },
    branch2Disabled: {
      get: function () {
        return this.isEntityDisabled(this.user.branch2);
      }
    },
    salesPeopleDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.sales_person_id);
      }
    },
    countriesDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.counties);
      }
    },
    bundesLandDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.german_region);
      }
    },
    actionNumberDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.action_number);
      }
    },
    taxRatesDisabled: {
      get: function () {
        return this.isEntityDisabled(this.user.tax_rates);
      }
    },
    editorialDynamic: {
      get: function () {
        return this.ef;
      }
    },
    titleGroupsDynamic: {
      get: function () {
        return this.tgf;
      }
    },
    customerGroupsDynamic: {
      get: function () {
        return this.cgf;
      }
    },
    branch2Dynamic: {
      get: function () {
        return this.braf;
      }
    },
    salesPeopleDynamic: {
      get: function () {
        return this.spf;
      }
    },
    countriesDynamic: {
      get: function () {
        if (this.isAdmin) {
          return this.countries;
        }
        return this.countf;
      }
    },
    bundesLandDynamic: {
      get: function () {
        if (this.isAdmin) {
          return this.bundesLand;
        }
        return this.blf;
      }
    },
    taxRatesDynamic: {
      get: function () {
        if (this.isAdmin) {
          return this.taxRates;
        }
        return this.taxf;
      }
    },
    actionNumbersDynamic: {
      get: function () {
        return this.anf;
      }
    },
    customersType: {
      get: function () {
        return [
          {value: "I", label: "Institutionelle Kunden"},
          {value: "P", label: "Privatkunden"}
        ];
      }
    }
  },
  methods: {
    resetRelatedEntites: function (e) {
      var self = this;

      resetSearchForm().then(function () {
        self.fillRelatedEntities(e);
      });
    },
    fillRelatedEntities: function (e) {
      var self = this;
      if (self.user.publisher_structure) {
        var currentStructure = self.user.publisher_structure.find(x => x.publisher_id == e);
      }

      self.ef = [];
      self.tgf = [];
      self.cgf = [];
      self.spf = [];
      self.countf = [];
      self.blf = [];
      self.taxf = [];
      self.braf = [];
      self.anf = [];

      this.selected.publisher_id = e;

      if ((e === null && typeof e === "object") || e == 'undefined') {
        this.canSubmit = false;
      } else {
        this.canSubmit = true;
        if (typeof window[this.publisherChangedFunction] === 'function') {
          window[this.publisherChangedFunction]();
        }

        if (this.inArray(this.selected.publisher_id, Object.keys(this.publisherGroups[0]))) {
          self.subpublishers = [];
          this.isHeadOfGroup = true;
          var ids = this.publisherGroups[0][this.selected.publisher_id];
          this.subPublishersStorage.forEach(function (element) {
            if (self.inArray(element.value, ids ? ids : [])) {
              let subPublisherExist = false;

              self.subpublishers.forEach(function (elem) {
                if (element.value === elem.value) subPublisherExist = true;
              });

              if (!subPublisherExist) {
                self.subpublishers.push(element);
              }
            }
          });
        } else {
          this.isHeadOfGroup = false;
        }
      }

      if (this.editorials) {
        if (this.canSelectRedactionTitles || (!this.canSelectRedactionTitles && !this.inArray(this.selected.publisher_id, Object.keys(this.publisherGroups[0]) ? Object.keys(this.publisherGroups[0]) : {}))) {

          this.editorials.forEach(function (element) {
            if (e == element.publisher_id && element.value !== 'all') {
              self.ef.push(element);
            }
          });

          if (!this.isAdmin) {
            $('#select_by > select option[value="editorials"]').prop('disabled', (currentStructure.editorial_id[0] !== 'selectable'))
          }

          if (this.ef.length === 1 && !this.isAdmin && currentStructure.editorial_id[0] !== 'selectable' && currentStructure.editorial_id[0] !== 'all') {
            self.sel.editorial_id = self.ef[0].value;
            self.setValue('editorial_id', self.sel.editorial_id);
          }
        }
      }
      if (this.titleGroups) {
        if (this.canSelectRedactionTitles || (!this.canSelectRedactionTitles && !this.inArray(this.selected.publisher_id, Object.keys(this.publisherGroups[0]) ? Object.keys(this.publisherGroups[0]) : {}))) {
          this.titleGroups.forEach(function (element) {
            if (e == element.publisher_id && element.value !== 'all') {
              self.tgf.push(element);
            }
          });
        }

        if (!this.isAdmin) {
          $('#select_by > select option[value="title_groups"]').prop('disabled', (currentStructure.title_group_id[0] !== 'selectable'))
        }

        if (this.tgf.length == 1 && !this.isAdmin && currentStructure.title_group_id[0] !== 'selectable' && currentStructure.title_group_id[0] !== 'all') {
          self.sel.title_group_id = this.tgf[0].value;
          self.setValue('title_group_id', self.sel.title_group_id);
        }
      }
      if (this.customerGroups) {
        var allCustomerGroup = false;

        self.customerGroups.forEach(function (element) {
          if (e == element.publisher_id && element.value !== 'all') {
            self.cgf.push(element);
          }
          if (e == element.publisher_id && element.value === 'all') {
            allCustomerGroup = true;
          }
        });

        if (e && self.cgf.length == 0 && !allCustomerGroup) {
          var customer_group_id = ['all'];

          if (self.user.publisher_structure !== undefined) {
            self.user.publisher_structure.forEach(function (structure) {
              if (e == structure.publisher_id) {
                customer_group_id = structure.customer_group_id;
              }
            });
          }

          self.customerGroups.forEach(function (element) {
            customer_group_id.forEach(function (group) {
              if (element.publisher_id == 0 && (group == element.value || group == 'selectable' || (self.isAdmin && group == 'all'))) {
                self.cgf.push(element);
              }
            });
          });
        }

        if (!this.isAdmin) {
          $('#select_by > select option[value="customer_groups"]').prop('disabled', (currentStructure.customer_group_id[0] !== 'selectable'));
        }

        if (self.cgf.length == 1 && !this.isAdmin && currentStructure.customer_group_id[0] !== 'selectable' && currentStructure.customer_group_id[0] !== 'all') {
          self.sel.customer_group_id = self.cgf[0].value;
          self.setValue('customer_group_id', self.sel.customer_group_id);
        }
      }

      if (this.branch2) {
        self.branch2.forEach(function (element) {
          if (e == element.publisher_id && element.value !== 'all') {
            self.braf.push(element);
          }
        });

        if (self.braf.length == 1 && !this.isAdmin && currentStructure.branch2[0] !== 'selectable' && currentStructure.branch2[0] !== 'all') {
          self.sel.branch2 = self.braf[0].value;
          self.setValue('branch2', self.sel.branch2);
        }
      }

      if (this.salesPeople) {
        this.salesPeople.forEach(function (element) {
          if (e == element.publisher_id && element.value !== 'all') {
            self.spf.push(element);
          }
        });

        if (!this.isAdmin) {
          $('#select_by > select option[value="sales_people"]').prop('disabled', (currentStructure.sales_person_id[0] !== 'selectable'));
        }

        if (self.spf.length == 1 && !this.isAdmin && currentStructure.sales_person_id[0] !== 'selectable' && currentStructure.sales_person_id[0] !== 'all') {
          self.sel.sales_person_id = self.spf[0].value;
          self.setValue('sales_person_id', self.sel.sales_person_id);
        }
      }

      if (this.countries) {
        this.countries.forEach(function (element) {
          if (element.publisher_id && e == element.publisher_id && element.value !== 'all') {
            self.countf.push(element);
          }
        });
        if (self.countf.length == 1 && !this.isAdmin && currentStructure.country[0] !== 'selectable' && currentStructure.country[0] !== 'all') {
          self.sel.country = self.countf[0].value;
          self.setValue('country', self.sel.country);
        }
      }

      if (this.bundesLand) {
        this.bundesLand.forEach(function (element) {
          if (element.publisher_id && e == element.publisher_id && element.value !== 'all') {
            self.blf.push(element);
          }
        });

        if (!this.isAdmin) {
          $('#select_by > select option[value="bundes_land"]').prop('disabled', (currentStructure.german_region[0] !== 'selectable'));
        }
        if (self.blf.length == 1 && !this.isAdmin && currentStructure.bundesland_id[0] !== 'selectable' && currentStructure.bundesland_id[0] !== 'all') {
          self.sel.bundesland_id = self.blf[0].value;
          self.setValue('bundesland_id', self.sel.bundesland_id);
        }
      }
      if (this.taxRates) {
        this.taxRates.forEach(function (element) {
          if (!Array.isArray(element) && e == element.publisher_id && element.value !== 'all') {
            self.taxf.push(element);
          }

          if (Array.isArray(element)) {
            element.forEach(function (el) {
              if (el.publisher_id == e && el.value !== 'all') {
                self.taxf.push(el);
              }
            });
          }
        });
        if (!this.isAdmin) {
          $('#select_by > select option[value="tax_rates"]').prop('disabled', (currentStructure.tax_rate.label !== 'selectable'));
        }
      }

      if (this.actionNumbers) {
        this.actionNumbers.forEach(function (element) {
          if (e == element.publisher_id && element.value !== 'all') {
            self.anf.push(element);
          }
        });

        if (this.anf.length === 1 && !this.isAdmin && currentStructure.action_number[0] !== 'selectable' && currentStructure.action_number[0] !== 'all') {
          self.sel.action_number = self.anf[0].value;
          self.setValue('action_number', self.sel.action_number);
        }
      }
    },
    setValue: function (id, val) {
      var es = $('#' + id);
      if (es.length > 0) {
        setTimeout(function () {
          es.select2().select2('destroy').select2().val(val).trigger('change');
        });
      }
    },
    isEntityDisabled(entity) {
      var isDisabled = false;

      if (entity === 'all') {
        isDisabled = true;
      }
      return isDisabled;
    },

    inArray(needle, haystack, field) {
      return (field === undefined) ? haystack.some(el => el == needle) : haystack.some(el => el[field] == needle);
    },
    countryChange(entry) {
      ((typeof entry === 'object' && entry.constructor === Array) && entry.indexOf('D') > -1) ? this.showBundesland = true : ((typeof entry === 'string' || entry instanceof String) && entry === 'D') ? this.showBundesland = true : this.showBundesland = false;
    }
  },
  mounted() {
    this.$nextTick(function () {

      if ((!this.selected.publisher_id) && (this.defaultPublisher)) {
        this.selected.publisher_id = this.defaultPublisher;
      }

      this.countryChange(this.selected.country);
      this.fillRelatedEntities(this.selected.publisher_id);
    });
  }
};

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PublisherRelatedFilterComponent.vue